module.exports = __webpack_public_path__ + "static/media/wechatQR.ac9bb31b.png";